// Add Data to product data that potentially can/should be aded tp PIM and retrieved via Backend
import {colourMapping, displayStyleMapping, regionMapping} from '../augmentProductData';

export const augmentProductDataMiddleware = store => next => action => {
	if (action.type === 'productData/productDataLoading/fulfilled') {
		const mode = store.getState().status.mode;
		const region = store.getState().status.region;
		const model = store.getState().configuration.data.projects[0].project.featureModelId;
		//console.log('model', model);
		// add the color hax values depending on featureID /valueID
		action.payload.forEach(component => {

			component.features.forEach(feature => {

				if (feature.featureId === 'HS_LightEmission') {
					//feature.isVisible = false;
				}
				if (feature.featureId === 'HS_LightEmissionCAFilter') {
					//feature.isVisible = (region === 'fra');
				}
				if (feature.featureId === 'HS_LightEmissionCA') {
					feature.isVisible = false; // (region !== 'fra');
				}

				if (feature.featureId === 'HS_UpLight') {
					//feature.isVisible = false;
				}


				if (model === 'BollardExtern' || model === 'PoleTopExtern' || model === 'PoleLateralExtern' || model === 'WallSurfaceExtern' || model === 'WallRecessedExtern') {
					if (feature.featureId === 'LE_LightEngineModuleSize_1') {
						//feature.isVisible = true;
					}
					if (feature.featureId === 'LE_LightEngineModuleSize_2') {
						// feature.isVisible = false;
					}
				}
				if (model === 'ColumnExtern') {
					if (feature.featureId === 'HS_HousingMountingLocationEblock_2') {
						//feature.isVisible = true;
					}
				}
				if (feature.featureId === 'HS_HousingHeight') {
					// feature.isVisible = true;
				}

				// add displaystyle to features
				feature.displayStyle = displayStyleMapping[mode][feature.featureId] ?? 'compactSelect';

				// add regional visibility to features and values
				feature.includeRegions = regionMapping[feature.featureId]?.includeRegions ?? null;
				feature.excludeRegions = regionMapping[feature.featureId]?.excludeRegions ?? null;

				feature.values.forEach(value => {
					value.displayColour = colourMapping[value.valueId] ?? '#0f0';
					value.includeRegions = regionMapping[feature.featureId]?.values[value.valueId]?.includeRegions ?? null;
					value.excludeRegions = regionMapping[feature.featureId]?.values[value.valueId]?.excludeRegions ?? null;
				});

				// add colorValues to FeatureValues
				switch (feature.featureId) {
					case 'HS_HousingColour':
					case 'LE_ReflectorColour_1':
					case 'LE_ReflectorColour_2':
						feature.values.forEach(value => {
							value.displayColour = colourMapping[value.valueId] ?? '#0f0';
						});
						break;
				}
				switch (feature.featureId) {
					case 'LE_DimmingLevel_1':
						// feature.isVisible = false;
						break;
				}
			});
		});

	}
	return next(action);
};
